import React, {useState, useEffect, useCallback} from 'react';
import {Box, createTheme, useMediaQuery, ThemeProvider} from '@mui/material';
import Cookies from 'js-cookie';
// import nookies from 'nookies';
import PageNav from '../../components/PageNav';
import {
  AddCircleIcon,
  macWP,
  IconDownload,
  IconDelete,
  IconRename,
} from '../../assets';
import {Language} from '../../context/LanguageContext';
import {ModalFlexible, UploadDataCenterCard} from '../../components';
import {Search} from '@material-ui/icons';
import {useUser} from '../../hooks';
import {DOCUMENTATION_TAB_LIST} from '../../consts/common';
import '../../assets/styles/userListV2.scss';
import {useNavigate} from 'react-router-dom';

export default function Documentation({type}) {
  const navigate = useNavigate();
  const [payload, setPayload] = useState({
    tab: DOCUMENTATION_TAB_LIST[0]?.value,
    q: '',
  });
  const [currentId, setCurrentId] = useState(DOCUMENTATION_TAB_LIST[0]?.value);
  const [openModal, setOpenModal] = useState(false);
  const [modalType, setModalType] = useState('');
  const {language, newObj} = Language();
  const tokens_session = Cookies.get('token');
  // const cookies = nookies.get();
  // const tokens_session = cookies.token;
  const {getDocumentationList, deleteDocumentation, downloadDocumentation} =
    useUser();
  const [userAccessList, setUserAccessList] = useState([]);
  const tabList = DOCUMENTATION_TAB_LIST;
  const [selected, setSelected] = useState(null);
  const [currentPath, setCurrentPath] = useState(
    DOCUMENTATION_TAB_LIST[0]?.path
  );
  const theme = createTheme({
    typography: {
      fontFamily: ['Montserrat'],
    },
  });
  const isXsScreen = useMediaQuery(theme.breakpoints.between('xs', 'sm'));
  const isSmScreen = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  const handleAddButton = (type) => {
    switch (type) {
      case 'documentation':
        navigate(
          `/upload-documentation?parentId=${currentId}&path=${currentPath}`
        );
        break;
      default:
        break;
    }
    setOpenModal(true);
  };
  const addButtonText = (type) => {
    switch (type) {
      case 'documentation':
        return newObj.AddFileWord[language];
      default:
        return '';
    }
  };
  const additionalButton = (type) => {
    switch (type) {
      case 'documentation':
        return (
          <button
            className='add_new_btn'
            onClick={() => {
              setModalType('addFolder');
              setOpenModal(true);
              setSelected({
                file: '',
                parentId: currentId,
                path: currentPath,
                type: 'folder',
              });
            }}
          >
            {newObj.NewFolderWord[language]}
          </button>
        );
      default:
        return;
    }
  };
  const uploadDataCenterCardProps = (type, item) => {
    let ext = '';
    if (item.type !== 'folder') {
      ext = item?.key.split('.')[item?.key.split('.').length - 1];
    }

    switch (type) {
      case 'documentation':
        return {
          text: item.name,
          type: item.type,
          ext,
          onClick: () => {
            if (item.type === 'folder') {
              setCurrentId(item.guid);
              setCurrentPath(item.path + item.name + '/');
            }
          },
          options: [
            {
              text: newObj.DownloadWord[language],
              onClick: async () => {
                const data = await downloadDocumentation(tokens_session, {
                  path: item.path,
                  filename: item.key,
                });
                if (data?.status === 200) {
                  const url = window.URL.createObjectURL(new Blob([data.data]));
                  const link = document.createElement('a');
                  link.href = url;
                  link.setAttribute('download', item.key);
                  document.body.appendChild(link);
                  link.click();
                  link.remove();
                  window.URL.revokeObjectURL(url);
                }
              },
              icon: IconDownload,
            },
            {
              text: newObj.RenameWord[language],
              onClick: () => {
                setModalType('editFolder');
                setOpenModal(true);
                setSelected({
                  id: item.guid,
                  type: item.type,
                });
              },
              icon: IconRename,
            },
            {
              text: newObj.DeleteWord[language],
              onClick: () => {
                setModalType('delete');
                setOpenModal(true);
                setSelected({
                  title: 'Are you sure you want to delete this folder?',
                  onClose: () => setOpenModal(false),
                  onSubmit: async () => {
                    await deleteDocumentation(tokens_session, {
                      id: item.id,
                    });
                    await handleGetDataList(tokens_session, payload);
                    setOpenModal(false);
                  },
                });
              },

              icon: IconDelete,
            },
          ],
        };
      default:
        return;
    }
  };
  const handleGetDataList = useCallback(
    async (tokens_session, payload) => {
      let response = null;
      switch (type) {
        case 'documentation':
          response = await getDocumentationList(tokens_session, {
            q: payload.q,
            id: currentId,
          });
          break;
        default:
          break;
      }
      const {data} = response;
      setUserAccessList(data.data || []);
    },
    [type, payload, tokens_session, currentId]
  );

  const pageNavProps = (type) => {
    switch (type) {
      case 'documentation':
        return {
          title: newObj.DocumentationWord[language],
          href: '/adminpage',
        };
      default:
        return;
    }
  };
  useEffect(() => {
    handleGetDataList(tokens_session, {
      q: payload.q,
      id: currentId,
    });
  }, [tokens_session, currentId]);

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          backgroundImage: `url(${macWP})`,
          backgroundRepeat: 'no-repeat',
          backgroundColor: (t) =>
            t.palette.mode === 'light'
              ? t.palette.grey[50]
              : t.palette.grey[900],
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          paddingTop: isXsScreen || isSmScreen ? '10px' : '20px',
          display: 'flex',
          justifyContent: 'center',
          minHeight: '100vh',
        }}
      >
        <PageNav {...pageNavProps(type)} />
        <Box className='userlist_ctr'>
          <Box className='userlist_box'>
            <Box className='userlist_head'>
              <Box className='left'>
                <Box className='tab_ctr'>
                  {tabList.map((tab, index) => (
                    <button
                      key={tab.value + index}
                      className={`tab ${
                        payload.tab === tab.value ? 'active' : ''
                      }`}
                      onClick={() => {
                        setPayload((prev) => ({...prev, tab: tab.value}));
                        setCurrentId(tab.value);
                        setCurrentPath(tab.path);
                      }}
                    >
                      {tab.label}
                    </button>
                  ))}
                </Box>
              </Box>
              <Box className='right'>
                <form
                  className='search_input_ctr'
                  onSubmit={(e) => {
                    e.preventDefault();
                    handleGetDataList(tokens_session, payload);
                  }}
                  action='POST'
                >
                  <input
                    type='text'
                    name='q'
                    onChange={(e) =>
                      setPayload((prev) => ({...prev, q: e.target.value}))
                    }
                    className='search_input'
                  />
                  <Search className='search_icon' />
                </form>
                {additionalButton(type)}
                <button
                  className='add_new_btn'
                  onClick={() => handleAddButton(type)}
                >
                  <img src={AddCircleIcon} alt='' />
                  {addButtonText(type)}
                </button>
              </Box>
            </Box>
            <Box className='userlist_card_ctr'>
              {userAccessList.map((item) => (
                <UploadDataCenterCard
                  {...uploadDataCenterCardProps(type, item)}
                />
              ))}
            </Box>
          </Box>
        </Box>
      </Box>
      {openModal && (
        <ModalFlexible
          type={modalType}
          data={{selected}}
          onClose={() => {
            handleGetDataList(tokens_session, payload);
            setOpenModal(false);
            setSelected(null);
          }}
        />
      )}
    </ThemeProvider>
  );
}
